import comp from "/home/runner/work/docs/docs/src/.vuepress/.temp/pages/docs/debugging/bugreport.html.vue"
const data = JSON.parse("{\"path\":\"/docs/debugging/bugreport.html\",\"title\":\"Bug Reporting\",\"lang\":\"en-US\",\"frontmatter\":{},\"headers\":[],\"git\":{\"updatedTime\":1774655546000},\"filePathRelative\":\"docs/debugging/bugreport.md\"}")
export { comp, data }
